const initState = {
	trivia: [],
	turnIndex: 0,
	playerIndex: 0
};

const quizDataReducer = (state = initState, action) => {
	switch (action.type) {
		case "LOAD_TRIVIA":
			return action.payload;
		case "UNLOAD_TRIVIA":
			return initState;
		case "NEXT_PLAYER":
			return {
				...state,
				playerIndex: action.payload
			};
		case "NEXT_TURN":
			return {
				...state,
				turnIndex: action.payload
			};
		case "INCREMENT_SCORE":
			return {
				...state,
				trivia: action.payload
			};
		default:
			return state;
	}
};

export default quizDataReducer;
